<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="dark-header">
          <h4 class="title">Tin tức và khuyến mại</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <md-button class="md-success button-add" @click="addNews"
              >Thêm mục</md-button
            >
          </div>
          <div class="scroll-x">
            <table id="table-news">
              <tr>
                <th>STT</th>
                <th>Tiêu đề</th>
                <th>Loại tin</th>
                <th>Ngày bắt đầu</th>
                <th>Ngày hết hạn</th>
                <th>Tin nổi bật</th>
                <th></th>
              </tr>
              <tr
                v-for="(item, index) in queriedData"
                :key="index"
                class="clickable"
              >
                <td @click="handleEdit(item)">{{ index + 1 }}</td>
                <td @click="handleEdit(item)">{{ item.data.title }}</td>
                <td @click="handleEdit(item)">{{ item.data.type }}</td>
                <td @click="handleEdit(item)">
                  {{
                    item.data.startDate
                      ? formatDate(new Date(item.data.startDate)).substring(
                          0,
                          11
                        )
                      : "Trống"
                  }}
                </td>
                <td @click="handleEdit(item)">
                  {{
                    item.data.endDate
                      ? formatDate(new Date(item.data.endDate)).substring(0, 11)
                      : "Trống"
                  }}
                </td>
                <td>
                  <md-checkbox
                    v-model="item.data.hotNews"
                    @change="updateNews(item)"
                    style="margin-left: 50px"
                  ></md-checkbox>
                </td>
                <td
                  class="clickable text-center"
                  @click="removeItem(item)"
                  style="color: red"
                >
                  <i class="far fa-trash-alt"></i>
                  <md-tooltip>Xóa tin</md-tooltip>
                </td>
              </tr>
            </table>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Hiển thị tin tức từ {{ from + 1 }} đến {{ to }}
            </p>
          </div>
          <span v-show="queriedData.length < pagination.perPage"
            >Đã tải hết dữ liệu ({{ listNews.length }} mục)</span
          >
          <div class="pagination clickable">
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </pagination>
          </div>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>
<script>
import firebase from "@/services/firebase-init.js";
import Swal from "sweetalert2";
import { Pagination } from "@/components";
export default {
  components: {
    Pagination,
  },
  created() {
    this.db = firebase.firestore();
    this.getData(this.pagination.perPage * 2);
  },
  data() {
    return {
      pagination: {
        perPage: 40,
        currentPage: 1,
        total: 0,
      },
      listNews: [],
      db: {},
      isAddNews: false,
      isRemove: false,
    };
  },
  methods: {
    getData(num) {
      this.listNews = [];
      this.$store.dispatch("FLAG_LOADING", true);
      let bits = localStorage.getItem("bits");
      this.db
        .collection(process.env.VUE_APP_NEWS + bits)
        .orderBy("createDate", "desc")
        .limit(num ? num : this.pagination.perPage)
        .get()
        .then((doc) => {
          doc.forEach((item) => {
            this.listNews.push({
              id: item.id,
              data: item.data(),
            });
          });
          this.$store.dispatch("FLAG_LOADING", false);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    previusPage() {
      if (this.pagination.currentPage !== 1) {
        this.pagination.currentPage--;
      }
    },
    async nextPage() {
      if (
        this.queriedData[this.queriedData.length - 1] ===
          this.listNews[this.listNews.length - this.pagination.perPage - 1] &&
        this.queriedData.length === this.pagination.perPage
      ) {
        this.pagination.currentPage++;
        await this.getData(null);
      } else if (
        this.queriedData[this.queriedData.length - 1] !==
        this.listNews[this.listNews.length - 1]
      )
        this.pagination.currentPage++;
      else alert("Đã hết dữ liệu");
    },
    addNews() {
      this.$emit("addNews");
    },
    handleEdit(item) {
      if (item === null) {
        this.isRemove = false;
      }
      if (!this.isRemove && item !== null) {
        this.$emit("editItem", item);
      }
    },
    updateNews(doc) {
      console.log(doc.data.hotNews);
      var bits = localStorage.getItem("bits");
      this.$store.dispatch("FLAG_LOADING", true);
      this.db
        .collection(process.env.VUE_APP_NEWS + bits)
        .doc(doc.id)
        .update(doc.data)
        .then(() => {
          this.$messageSuccess("Đã cập nhật tin nổi bật");
          this.$store.dispatch("FLAG_LOADING", false);
        });
    },
    removeItem(item) {
      this.isRemove = true;
      Swal.fire({
        title: "Xóa mục",
        text: `Mục này sẽ bị xóa khỏi danh sách`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let bits = localStorage.getItem("bits");
          this.db
            .collection(process.env.VUE_APP_NEWS + bits)
            .doc(item.id)
            .delete()
            .then(() => {
              this.$messageSuccess("Xóa mục thành công");
              this.getData(this.pagination.perPage * 2);
              this.$emit("completeRemove");
            })
            .catch((error) => {
              this.$messageError("Lỗi, vui lòng thử lại");
              console.log(error);
            });
        } else this.isRemove = false;
      });
    },
  },
  computed: {
    queriedData: {
      get() {
        let result = this.listNews;
        return result.slice(this.from, this.to);
      },
      set(newName) {
        return newName;
      },
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.listNews.length;
    },
  },
  watch: {
    "pagination.currentPage"() {
      if (this.pagination.currentPage <= this.total / this.pagination.perPage) {
        this.getData(this.pagination.perPage);
      }
    },
  },
};
</script>
<style lang="css" scoped>
.button-add {
  float: right;
}

.danger {
  background-color: rgba(219, 110, 88, 0.329);
}
.table-border {
  border: solid rgba(0, 0, 0, 0.178) 1px;
  border-radius: 10px;
}
#table-news {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  border-radius: 10px;
}

#table-news td,
#table-news th {
  padding: 8px 10px 8px 10px;
  border: 1px solid #ddd;
  max-width: 20vh;
}

#table-news tr:nth-child(even) {
  background-color: #f2f2f2;
}

#table-news tr:hover {
  background-color: #ddd;
}

#table-news th {
  text-align: left;
  background-color: rgba(0, 165, 14, 0.356);
  color: rgb(0, 0, 0);
  font-style: normal;
  font-weight: normal;
}
.nummeric {
  text-align: right !important;
}
</style>
